<div class="header" fxLayoutGap="5px" fxLayout="row" fxLayoutAlign="center center">
    <img width="40px" src={{iconUrl}} alt="Icona trams perill">
    <span class="title" i18n>Tramo con nivel de riesgo</span>
</div>

<div class="content" >

    <div i18n>
        {{road}} entre el Km {{start_kp}} y el Km {{end_kp}}
    </div>
    <div>
        <span class="detail-name" i18n>Nivel de riesgo:</span> {{ levelOfServiceText }}
    </div>
   
</div>

<div class="source" fxLayout="row" fxLayoutAlign="space-between center">
    <div>
        <b i18n>Fuente:</b> RACC
    </div>
    
    <div fxLayout="row" fxLayoutGap="2px" fxLayoutAlign="center center">
        <a class="twitter-share-button share-button" href="https://twitter.com/intent/tweet?url={{generateShareUrl()}}&text={{generateShareText()}}">
            <img src="assets/img/twitter.png" width="22px" alt="">
        </a>
        <a href="mailto:?subject=RACC%20Infotransit&amp;body={{generateShareText()}}.%20Visita%20{{generateShareUrl()}}" class="share-button">
            <img src="assets/img/emailBlack.png" width="24px" alt="">
        </a>
    </div>
    
</div>





